<div [class.screen-height]="!supplierJobStoreService.isGridView">
  <div *ngIf="selectedTab">
    <div class="sub-header-line flex">
      <div class="flex-grow-1 flex flex-row flex-wrap">
        <div class="sub-header">
          <span *ngIf="inboxSubType == 1">Jobs Search</span>
          <span *ngIf="inboxSubType == 2">My Jobs</span>
        </div>
        <div class="flex-grow-1">
          <p-selectButton
            [options]="inboxTabOptions"
            [(ngModel)]="selectedTab"
            class="inbox-tabs-select-button"
          >
            <ng-template let-item>
              {{ item.label }}
              <span class="ui-badge" *ngIf="inAvailableJobsTab(item.value)">
                <span *ngIf="loadingCounts"><i class="fa fa-spin fa-spinner"></i></span>
                <span *ngIf="!loadingCounts">{{ availableJobsCount(item.value) }}</span>
              </span>
            </ng-template>
          </p-selectButton>
          <div class="style2023 inbox-tabs-select-dropdown">
            <div class="input-group">
              <div class="input-group-item">
                <p-dropdown
                  [options]="inboxTabOptions"
                  [(ngModel)]="selectedTab"
                  class="input-group-filter"
                >
                  <ng-template let-option pTemplate="selectedItem">
                    <ng-container
                      [ngTemplateOutlet]="tabSelectOptionItem"
                      [ngTemplateOutletContext]="{
                        $implicit: option
                      }"
                    ></ng-container>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <ng-container
                      [ngTemplateOutlet]="tabSelectOptionItem"
                      [ngTemplateOutletContext]="{
                        $implicit: option
                      }"
                    ></ng-container>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-1" style="min-width: 65px; align-self: flex-end; padding-bottom: 3px">
        <ng-container [ngTemplateOutlet]="toggleGrid"></ng-container>
      </div>
    </div>
  </div>

  <div class="flex-shrink-1 filter-box">
    <form [formGroup]="filterForm">
      <div class="flex grid-gap-10 style2023 flex-wrap">
        <!-- PICKUP DISTANCE + DATE -->

        <div class="flex-grow-1 pickup-group" *ngIf="!isMyJobsTab(this.selectedTab)">
          <div class="input-group">
            <div class="input-group-prepend group-label flex-shrink-1">Pick-up</div>
            <div class="input-group-item flex-grow-1">
              <div class="flex">
                <div class="flex-shrink-1 pr-2">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div class="flex-grow-1">
                  <p-dropdown
                    #pickupDropDown
                    (onChange)="pickupDistanceFromChanged($event)"
                    [options]="pickupDistanceFromOptions"
                    [placeholder]="'From...'"
                    class="input-group-filter search-location-dropdown"
                    formControlName="pickupDistanceFrom"
                    [showClear]="true"
                  >
                    <ng-template let-option pTemplate="item">
                      <ng-container
                        [ngTemplateOutlet]="dropDownEdit"
                        [ngTemplateOutletContext]="{
                          option: option,
                          pickupDropoff: 'pickup'
                        }"
                      ></ng-container>
                    </ng-template>

                    <ng-template let-option pTemplate="selectedItem">
                      <span [innerHTML]="optionLabel(option, PickupOrDropoff.Pickup)"></span>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
            <div class="input-group-prepend group-label">Within</div>
            <div class="input-group-item flex-grow-1">
              <p-dropdown
                [options]="pickupDistanceOptions"
                class="input-group-filter"
                [formControl]="formControls.pickupMaxDistance"
                [showClear]="true"
                placeholder="Distance"
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                (keyup)="
                  inputHelper.integerOnly($event.target);
                  onPickupDistanceChange($event.target?.value)
                "
                [editable]="true"
              ></p-dropdown>
            </div>
            <div class="input-group-prepend group-label">Miles</div>
          </div>
        </div>

        <!-- DROPOFF DISTANCE + DATE -->

        <div class="flex-grow-1 pickup-group" *ngIf="!isMyJobsTab(this.selectedTab)">
          <div class="input-group">
            <div class="input-group-prepend group-label">Drop-off</div>
            <div class="input-group-item">
              <div class="flex">
                <div class="flex-shrink-1 pr-2">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div class="flex-grow-1">
                  <p-dropdown
                    #dropoffDropDown
                    (onChange)="dropoffDistanceFromChanged($event)"
                    [options]="dropoffDistanceFromOptions"
                    [placeholder]="'To...'"
                    class="input-group-filter search-location-dropdown"
                    formControlName="dropoffDistanceFrom"
                    [showClear]="true"
                  >
                    <ng-template let-option pTemplate="item">
                      <ng-container
                        [ngTemplateOutlet]="dropDownEdit"
                        [ngTemplateOutletContext]="{
                          option: option,
                          pickupDropoff: 'dropoff'
                        }"
                      ></ng-container>
                    </ng-template>

                    <ng-template let-option pTemplate="selectedItem">
                      <span [innerHTML]="optionLabel(option, PickupOrDropoff.Dropoff)"></span>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
            <div class="input-group-prepend group-label">Within</div>
            <div class="input-group-item">
              <p-dropdown
                [options]="dropoffDistanceOptions"
                class="input-group-filter"
                [formControl]="formControls.dropoffMaxDistance"
                [showClear]="true"
                placeholder="Distance"
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                (keyup)="
                  inputHelper.integerOnly($event.target);
                  onDropoffDistanceChange($event.target?.value)
                "
                [editable]="true"
              ></p-dropdown>
            </div>
            <div class="input-group-prepend group-label">Miles</div>
          </div>
        </div>
      </div>
      <div class="flex grid-gap-10 style2023 flex-wrap">
        <div class="flex grid-gap-10 flex-grow-1 flex-wrap mt-2">
          <!-- DATE OF JOB -->

          <div class="flex-grow-1" style="flex-basis: 250px; max-width: 300px">
            <div class="input-group">
              <div class="input-group-item flex align-items-center">
                <i
                  class="fa fa-calendar clickable-calendar-icon mr-2"
                  (click)="allDatesCalendar.showOverlay()"
                ></i>
                <p-calendar
                  #allDatesCalendar
                  [formControl]="formControls.dateOfJob"
                  selectionMode="range"
                  class="custom-calendar-template"
                  dateFormat="dd/mm/yy"
                  placeholder="All Dates"
                  [style]="{ width: '100%' }"
                  [inputStyle]="{ width: '100%' }"
                  (ngModelChange)="onCalendarDateChange()"
                >
                  <ng-template pTemplate="date" let-date>
                    <span [class]="customCalendarCellClass(date, formControls.dateOfJob.value)">{{
                      date.day
                    }}</span>
                  </ng-template>
                </p-calendar>
              </div>
              <div
                class="input-group-append"
                *ngIf="formControls.dateOfJob.value != null"
                (click)="resetDateOfJob()"
              >
                <i class="pi pi-times vertical-align-middle"></i>
              </div>
            </div>
          </div>

          <div class="flex-shrink-1" *ngIf="isMyJobsTab(this.selectedTab)">
            <div class="input-group">
              <div class="input-group-item" style="position: relative">
                <div style="position: absolute; top: 0px; left: 10px; font-size: 18px; color: #888">
                  <i class="las la-search"></i>
                </div>
                <input
                  style="padding-left: 25px; width: 150px"
                  [formControl]="formControls.regNo"
                  class="form-control"
                  pInputText
                  placeholder="Search Reg"
                />
              </div>
            </div>
          </div>

          <div class="flex-grow-1" style="flex-basis: 100px" *ngIf="!isMyJobsTab(this.selectedTab)">
            <div class="input-group">
              <div class="input-group-item">
                <p-dropdown
                  [options]="totalDistanceOptions"
                  class="input-group-filter"
                  [formControl]="formControls.totalDistance"
                  (onChange)="onTotalDistanceChange($event)"
                  [showClear]="true"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div class="flex-grow-1" style="flex-basis: 100px" *ngIf="!isMyJobsTab(this.selectedTab)">
            <div class="input-group">
              <div class="input-group-item">
                <p-dropdown
                  [options]="movementTypeOptions"
                  class="input-group-filter"
                  [formControl]="formControls.movementType"
                  (onChange)="onMovementTypeChange($event)"
                  [showClear]="true"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div class="flex-grow-1" style="flex-basis: 100px" *ngIf="!isMyJobsTab(this.selectedTab)">
            <div class="input-group">
              <div class="input-group-item">
                <p-dropdown
                  [options]="fuelTypeOptions"
                  class="input-group-filter"
                  (onChange)="onFuelTypeChange($event)"
                  [formControl]="formControls.excludeElectric"
                  [showClear]="true"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div class="flex-shrink-1 flex grid-gap-10 flex-wrap">
            <div class="flex-shrink-1 cursor-pointer">
              <button class="button-style" (click)="submitSearch()">
                <i class="fa fa-search"></i>&nbsp;Search
              </button>
            </div>

            <div class="flex-shrink-1">
              <div class="button-style ui-button-tertiary transparent" (click)="resetForm()">
                <i class="fa fa-undo"></i>
              </div>
            </div>

            <div class="flex-shrink-1" style="min-width: 100px">
              <div class="input-group">
                <div class="input-group-item">
                  <p-dropdown
                    [options]="filteredSortOptions"
                    optionLabel="label"
                    [(ngModel)]="selectedSortOption"
                    (onChange)="handleSortChange($event)"
                    placeholder="Sort By"
                    [ngModelOptions]="{ standalone: true }"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #dropDownEdit let-option="option" let-pickupDropoff="pickupDropoff">
        <span *ngIf="option.custom" style="line-height: 15px" (click)="switchToDataEntry($event)">
          <!-- Padding/Margin added to allow the entire li to be reactive to the DataEntrySwitch -->
          <div class="flex" style="margin: -10px -13px; padding: 10px 13px">
            <div class="flex-shrink-1 postcode-input-icon"><i class="fa fa-search"></i>&nbsp;</div>
            <div class="flex-grow-1 postcode-input-icon" *ngIf="!dataEntry">
              <span [innerHTML]="optionLabel(option, pickupDropoff)"></span>
            </div>
            <div class="flex-grow-1 pl-1" *ngIf="dataEntry">
              <input
                *ngIf="pickupDropoff === 'pickup'"
                #pickupPlacesAutocomplete
                type="text"
                style="width: 100%"
                (keydown.enter)="$event.preventDefault()"
              />
              <input
                *ngIf="pickupDropoff === 'dropoff'"
                #dropoffPlacesAutocomplete
                type="text"
                style="width: 100%"
                (keydown.enter)="$event.preventDefault()"
              />
            </div>

            <!--            <div-->
            <!--              class="flex-shrink-1 pl-3 postcode-input-icon"-->
            <!--              (click)="saveCustomPostcode($event, pickupDropoff)"-->
            <!--              *ngIf="dataEntry"-->
            <!--            >-->
            <!--              <i class="pi pi-check" style="color: var(&#45;&#45;linkColor)"></i>-->
            <!--            </div>-->

            <!--            <div-->
            <!--              class="flex-shrink-1 pl-3 postcode-input-icon"-->
            <!--              (click)="cancelDataEntry(pickupDropoff)"-->
            <!--              *ngIf="dataEntry"-->
            <!--            >-->
            <!--              <i class="pi pi-times" style="color: var(&#45;&#45;text-color)"></i>-->
            <!--            </div>-->
          </div>
        </span>
        <span *ngIf="!option.custom">
          <i class="fa {{ option.icon }}"></i>&nbsp;<span
            [innerHTML]="optionLabel(option, pickupDropoff)"
          ></span>
        </span>
      </ng-template>
    </form>
  </div>

  <div
    class="h-100"
    style="overflow-y: hidden"
    [class.ui-g]="!SupplierInboxType.InboxRecommendation"
  >
    <div class="h-100" [ngClass]="supplierJobStoreService.isGridView ? 'ui-g-12' : 'ui-g-12'">
      <div class="h-100">
        <div class="old-content-box h-100">
          <div class="col-12 p-nogutter no-padding h-100">
            <supplier-jobs-card
              [inboxType]="selectedTab"
              [filterVal]="searchParameters"
              [googleAnalyticsEventLabel]="jobSearchPageTitle"
              [supplierJobChannel]="supplierJobChannel"
              *ngIf="!supplierJobStoreService.isGridView"
            >
            </supplier-jobs-card>
            <supplier-jobs-grid
              [inboxType]="selectedTab"
              [filterVal]="searchParameters"
              [supplierJobChannel]="supplierJobChannel"
              *ngIf="supplierJobStoreService.isGridView"
            >
            </supplier-jobs-grid>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="selectedJob?.job && supplierJobStoreService.isGridView">
      <div style="height: 100%">
        <div style="height: 100%; padding-right: 10px">
          <div style="height: 100%; padding: 0 10px">
            <div
              style="
                background-color: #fff;
                border-radius: 10px;
                padding: 10px;
                margin-bottom: 75px;
              "
            >
              <div style="font-weight: 500; font-size: 18px; margin-bottom: 10px">
                Job Details {{ selectedJob?.job?.jobNumber }}
              </div>
              <supplier-job-screen-job-tasks
                [jobId]="selectedJob?.job?.id"
                *ngIf="selectedJob?.job"
              ></supplier-job-screen-job-tasks>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #toggleGrid>
  <div class="flex" style="flex-direction: column; height: 100%; justify-content: center">
    <p-selectButton
      [options]="gridOptions"
      class="layout-select-button"
      [ngModel]="supplierJobStoreService.isGridView"
      (onOptionClick)="layoutViewChanged($event)"
    >
      <ng-template let-item>
        <span>
          <i class="{{ item.icon }}"></i>
        </span>
      </ng-template>
    </p-selectButton>
  </div>
</ng-template>

<job-grabbed
  *ngIf="selectedJob?.job"
  [visible]="supplierJobStoreService.acceptJobDialogVisible$ | async"
  (visibleChange)="supplierJobStoreService.setAcceptJobDialogVisible($event)"
  [jobId]="selectedJob?.job?.id"
  [supplierPrice]="selectedJob?.job?.supplierPrice"
  (jobScheduleNow)="handleScheduleNow()"
></job-grabbed>

<travel-scheduler
  *ngIf="showTravelScheduler"
  [id]="selectedJob.job.id"
  (onCancel)="closeTravelScheduler()"
  (onCompleteSchedule)="handleScheduleCompleted()"
  [isAfterCutoff]="isScheduleRequired && inboxSubType == SupplierInboxSubType.JobSearch"
>
</travel-scheduler>

<allocate-driver-dialog
  *ngIf="selectedJob?.job"
  [visible]="supplierJobStoreService.allocateDriverDialogVisible$ | async"
  (visibleChange)="supplierJobStoreService.setAllocateDriverDialogVisible$($event)"
  [jobId]="selectedJob?.job?.id"
  (jobAllocated)="supplierJobStoreService.removeJob($event)"
>
</allocate-driver-dialog>

<allocate-depot-dialog
  *ngIf="selectedJob?.job"
  [visible]="supplierJobStoreService.allocateDepotDialogVisible$ | async"
  (visibleChange)="supplierJobStoreService.setAllocateDepotDialogVisible$($event)"
  [jobId]="selectedJob?.job?.id"
>
</allocate-depot-dialog>

<allocate-truck-dialog
  *ngIf="selectedJob?.job"
  [visible]="supplierJobStoreService.allocateTruckDialogVisible$ | async"
  (visibleChange)="supplierJobStoreService.setAllocateTruckDialogVisible$($event)"
  [jobId]="selectedJob?.job?.id"
>
</allocate-truck-dialog>

<hide-job-dialog
  *ngIf="selectedJob?.job"
  [visible]="supplierJobStoreService.hideJobDialogVisible$ | async"
  (visibleChange)="supplierJobStoreService.setHideJobDialogVisible($event)"
  [job]="selectedJob?.job"
  (jobHidden)="supplierJobStoreService.removeJob($event)"
>
</hide-job-dialog>

<ng-template #tabSelectOptionItem let-option>
  <div class="ui-helper-clearfix flex justify-content-between">
    <div class="flex-grow-1">{{ option.label }}</div>
    <span class="ui-badge" *ngIf="inAvailableJobsTab(option.value)">
      <span *ngIf="loadingCounts"><i class="fa fa-spin fa-spinner"></i></span>
      <span *ngIf="!loadingCounts">{{ availableJobsCount(option.value) }}</span>
    </span>
  </div>
</ng-template>

<a id="return-to-top-btn" (click)="scrollToTop()" [hidden]="hideScrollUpCtrl"
  ><i class="pi pi-chevron-up"></i
></a>
